/* unplugin-vue-components disabled */import script from "./OverView.vue?vue&type=script&setup=true&lang=js"
export * from "./OverView.vue?vue&type=script&setup=true&lang=js"

import "./OverView.vue?vue&type=style&index=0&id=2f16e27a&lang=scss"

const __exports__ = script;

export default __exports__